<template>
  <BaseLayout>
    <div
      class="md:flex-row relative backgroundImage py-6 md:p-0 flex flex-col items-center justify-center min-h-screen"
    >
      <div
        class="md:w-5/12 w-10/12 bg-white opacity md:opacity-100 rounded-md md:rounded-sm xl:h-screen xl:flex xl:flex-col"
      >
        <div class="p-6 xl:pt-8">
          <router-link :to="{ name: 'DashboardBeforeLogin' }">
            <img
              :src="require(`@/assets/img/fitclas.png`)"
              alt=""
              class="w-32 object-cover"
            />
          </router-link>
        </div>
        <div
          class="p-10 xl:flex-1 xl:flex xl:flex-col xl:justify-center xl:items-center xl:-mt-8"
        >
          <div class="xl:w-max">
            <h3 class="text-2xl font-semibold text-gray-800 italic">
              Change Password
            </h3>
            <p class="text-sm text-gray-800">
              In order to <span class="font-medium">protect your account</span>,
            </p>
            <p class="text-sm text-gray-800">
              make sure you do not share your password
            </p>
            <form class="mt-6 xl:w-80" @submit.prevent="handleChange">
              <div class="mt-2">
                <label class="block">
                  <span class="text-gray-700 text-sm">Password</span>
                  <input
                    type="password"
                    minlength="8"
                    class="form-input mt-1 block w-full h-8"
                    v-model="$v.password.$model"
                    :class="{ 'border-red-500': $v.password.$error }"
                  />
                </label>
                <div v-if="$v.password.$error">
                  <small
                    class="text-red-500 text-sm"
                    v-if="!$v.password.required"
                  >
                    Password is required
                  </small>
                  <small
                    class="text-red-500 text-sm"
                    v-if="!$v.password.minLength"
                  >
                    Password minlength is 8
                  </small>
                </div>
              </div>

              <div class="mt-2">
                <label class="block">
                  <span class="text-gray-700 text-sm">Confirm Password</span>
                  <input
                    type="password"
                    min="8"
                    class="form-input mt-1 block w-full h-8"
                    v-model="$v.confirmation.$model"
                    :class="{ 'border-red-500': $v.confirmation.$error }"
                  />
                </label>
                <div v-if="$v.confirmation.$error">
                  <p
                    class="text-red-500 text-sm"
                    v-if="!$v.confirmation.required"
                  >
                    Confirm Password is required
                  </p>
                  <p
                    class="text-red-500 text-sm"
                    v-if="!$v.confirmation.sameAsPassword"
                  >
                    Confirm Password is not same as Password
                  </p>
                </div>
              </div>

              <div class="mt-4">
                <Button> CHANGE PASSWORD </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div class="hidden md:inline md:w-7/12">
        <img
          class="object-cover md:object-cover h-screen w-full"
          :src="require(`@/assets/img/login.webp`)"
          alt="..."
        />
      </div>
    </div>
  </BaseLayout>
</template>

<script>
import BaseLayout from "@/components/layouts/BaseLayout";
import { Button } from "@/components/t-components";
import { required, sameAs, minLength } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "ChangePassword",
  components: {
    BaseLayout,
    Button,
  },
  data() {
    return {
      password: null,
      confirmation: null,
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    confirmation: {
      required,
      sameAsPassword: sameAs("password"),
    },
  },
  methods: {
    ...mapActions(["changePassword"]),

    handleChange() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        console.log("invalid");
      } else {
        const data = {
          password: this.password,
          password_confirmation: this.confirmation,
          token: this.$route.params.token,
        };
        this.changePassword(data).then((res) => {
          this.$router.push({ name: "Login" });
        });
      }
    },
  },
};
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .backgroundImage {
    background-image: url("../assets/img/login.webp");
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }
  .opacity {
    opacity: 0.9;
  }
}
</style>